import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepCellInfoForm.html?raw';
import topic from 'dojo/topic';

import _tmplDayInfo from '../Templates/employmentDayRecord.html?raw';

import Button from '../../../moreCore/UI/Button/Button';

import { EntityHelpers, ToasterHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import PEPcellNotesData from './PepCellNotesData';
import { PEP } from "../PepTypes";
//import _PepBase = require("../_PepBase");



class PepCellInfoForm extends compose(_WidgetBaseSP) {
	templateString: any = template;

    private isDirty: boolean = false;

    private txtCellDate: HTMLElement;
    private txtCellContract: HTMLElement;

    private containerCellNotesData: HTMLElement;
    private employmentNotesContainer: HTMLElement;
    private employmentNotesInternalContainer: HTMLElement;
    private employmentInfoContainer: HTMLElement;

    private inputNotes: HTMLTextAreaElement;
    private inputNotesInternal: HTMLTextAreaElement;

    private _data: PEP.CellInfoData = null;
    private xData: PEP.XCol = null;
    private yData: PEP.YRow = null;
    private saveData: PEP.DayRecordSaveData = null;
    private _originalData: string = null;
    private _undirtyData: string = null;
    private _backupData: string = null;

    private btnRevert: HTMLElement;
    private btnSave: HTMLElement;

    private isReadOnly: boolean = false;


    setData(cellInfoData: PEP.CellInfoData, xData: PEP.XCol, yData: PEP.YRow): void {

        if (cellInfoData && cellInfoData?.xID == xData.ID && cellInfoData?.yID == yData.ID) {
            this._data = cellInfoData;
        } 

        this.xData = xData;
        this.yData = yData;

        let dayRecord: Partial<PEP.DayRecordInfo>;


        if (!this._data) {
            this._data = {
                xID: xData.ID,
                yID: yData.ID,
                dayRecordInfo: null,
                cellNotes: []
            };
        }

        if (!this._data.dayRecordInfo) {
            dayRecord = {

            };
            this._data.dayRecordInfo = dayRecord as any;

            // wenn es neu ist und wir eh kein Recht zum Bearbeiten haben, dann braucht das Property mit internen Anmerkungen gar nicht da sein
            // so bleibt es ausgeblendet.
            if (yData.descriptor.CanEditNoteInternalUse === true) {
                dayRecord.note_internal_use = "";
                dayRecord.CanEditNoteInternalUse = true;
            }
        }

        //console.debug(this.id + " setData", this._data, xData, yData);

        let data = this._data;
        dayRecord = this._data.dayRecordInfo;

        this.txtCellContract.innerHTML = yData.descriptor.label
        this.txtCellDate.innerHTML = xData.descriptor.label;

        if (this.hasFeature("PEP/EntityViewInCellInfo") && dayRecord?.dayRecordID) {
            let btn = new Button();
            btn.placeAt(this.txtCellContract, "only");

            btn.setup({
                callback: lang.hitch(this, this._onClick_EntityView),
                iconClass: "fas fa-info-circle",
                styleClass: "w3-block",
                label: yData.descriptor.label,
                secondaryLabel: xData.descriptor.label
            });

            this.txtCellDate.innerHTML = "";
        }

        let notes = "";
        if (dayRecord?.notes?.length) {
            for (let note of dayRecord.notes) {
                notes += note;
            }
        }

        this.inputNotes.value = notes;

        if (typeof (dayRecord.note_internal_use) != "undefined") {
            this.inputNotesInternal.value = dayRecord.note_internal_use;
            this.hideNode(this.employmentNotesInternalContainer, false);
            this.disableNode(this.inputNotesInternal, !dayRecord.CanEditNoteInternalUse);
        } else {
            this.hideNode(this.employmentNotesInternalContainer);
        }

        // Tagesdatensatz (4-spaltige Wertezeile)
        let dayRecordHTML = "";

        if (dayRecord.columns) {
            for (let col of dayRecord.columns) {
                dayRecordHTML += this.stringFormat(_tmplDayInfo,
                    col.label,
                    col.value,
                    col.colorationBG != "" ? col.colorationBG : "unset",
                    col.colorationTXT != "" ? col.colorationTXT : "unset",
                    col.tooltip,
                    col.grow
                );
            }
        }

        let dayRecordContainer = this.UiModder.domConstruct.create("div",
            { "innerHTML": dayRecordHTML, "className": "PEP_dayRecordInfo w3-block flex_row_center" }, this.employmentInfoContainer, "only");

        this.hideNode(this.employmentInfoContainer, dayRecord.columns?.length <= 0);

        this.serializeData(true);

        this.setReadonly(this.isReadOnly);

        let cellNotes = data.cellNotes;
        if (cellNotes?.length) {
            this.hideNode(this.containerCellNotesData, false);
            for (let data of cellNotes) {
                let notesInfo = new PEPcellNotesData();
                notesInfo.setData(data);
                notesInfo.placeAt(this.containerCellNotesData);
                notesInfo.on("update", lang.hitch(this, this._onUpdateCellNote));
            }
        }
    }

    setReadonly(readonly: boolean) {
        this.isReadOnly = readonly !== false;

        this.disableNode(this.domNode, this.isReadOnly);
    }

    private _onClick_EntityView(evt: MouseEvent) {
        if (this._data?.dayRecordInfo) {
            topic.subscribe("/Entity/Opened/" + this._data.dayRecordInfo.dayRecordID, lang.hitch(this, this._onOpenedEntityview));
            EntityHelpers.openEntityView({
                entityClass: this._data.dayRecordInfo.Classname,
                entityId: this._data.dayRecordInfo.dayRecordID,
                label: this.xData.descriptor.label,
                contextName: "PEPtable"
            });
        }
    }

    private _onOpenedEntityview(ev: MdsLax<InstanceType<typeof GenericEntityView>>) {
        if (ev) {
            debugger;
            ev.on("change", lang.hitch(this, this._onChangedEntityView));
        }
    }
    private _onUpdateCellNote() {
        this.emit("update");
    }
    private _onChangedEntityView() {
        this.emit("update");
    }

    private _onBlur_InputNotesInternal(evt: Event) {
        this.serializeData();
    }
     private _onBlur_InputNotes(evt: Event) {
         this.serializeData();
    }

    private _onClick_Revert(evt: MouseEvent) {
        this.setData(JSON.parse(this._backupData), this.xData, this.yData);
    }
    private _onClick_Save(evt: MouseEvent) {
        this.saveFormData();
    }
     private _onClick_Close(evt: MouseEvent) {
         this.emit("close");
    }

    private saveFormData() {

        this.serializeData();

        if (!this.isDirty) return;
        if (this.isReadOnly) return;

        this.StandbyStart();

        let url = window.appRoot + "Pep/SaveDayRecordInfo";

        let data = this.saveData;
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData,
            },
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError),
            false // sync
        );
    }

    private _onSaveDataResponse(response: { dayRecordID: string, dayRecordInfo: PEP.DayRecordInfo }) {

        if (response?.dayRecordID) {
            // bei neu erstellten Einträgen kommt jetzt erstmalig die dayRecordID, daher diese merken:
            this._data.dayRecordInfo.dayRecordID = response.dayRecordID;
            this.saveData.dayRecordID = response.dayRecordID;
        }

        this.StandbyStop();

        this.serializeData(true);

        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
            ID: "saveResult"
        });

        this.emit("saved", response.dayRecordInfo);
    }
    private _onSaveDataError(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.showToast({
            title: this.translate("General_SavingFailed"),
            message: error.Message,
            iconClass: ToasterHelpers.ToasterIcons.error,
            timeout: -1,
            showClose: true,
            ID: "saveResult"
        })
    }

    private serializeData(resetDirty?: boolean) {
        this.saveData = {
            dayRecordID: this._data?.dayRecordInfo?.dayRecordID,
            note: this.inputNotes.value,
            note_internal: this.inputNotesInternal.value,
            xID: this._data.xID,
            yID: this._data.yID
        };

        
        if (resetDirty == true) {
            this._undirtyData = JSON.stringify(this.saveData);

            // weil in der save-data nicht alles erfasst wird was zum Wiederherstellen nötig ist, eine separate Datenzusammenstellung machen:
            let currentData: PEP.CellInfoData = {
                ...this._data,
                dayRecordInfo: {
                    ...this._data.dayRecordInfo,
                    notes: [this.saveData.note],
                    note_internal_use: this.saveData.note
                },
                cellNotes: this._data.cellNotes

            };
            this._backupData = JSON.stringify(currentData);
        }

        if (this._originalData == null) this._originalData = this._undirtyData;

        this.isDirty = this._undirtyData != JSON.stringify(this.saveData);
        this.setDirtyStyles();
    }

    private setDirtyStyles() {
        this.disableNode(this.btnRevert, !this.isDirty);
        this.disableNode(this.btnSave, !this.isDirty);

       
    }

    private _onClick_Domnode(evt: MouseEvent) {

        evt.stopPropagation();
    }
    

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PepCellInfoForm);